import { type SupportedContractType } from "@repo/logic";
import { createContext, type FC, type PropsWithChildren, useContext } from "react";
import { PrimaryAPIClientContext, usePrimaryAPIClient } from "./PrimaryAPIClient";

export type IContractTypeContext = {
    contractType: SupportedContractType;
};

const ContractTypeContext = createContext<IContractTypeContext>({});

export function useContractTypeContext(): IContractTypeContext {
    return useContext(ContractTypeContext);
}

export type ContractTypeProviderProps = PropsWithChildren<{
    contractType?: SupportedContractType;
}>;

export const ContractTypeProvider: FC<ContractTypeProviderProps> = ({ children, contractType }) => {
    const APIs = usePrimaryAPIClient();
    return (
        <ContractTypeContext.Provider
            value={{
                contractType,
            }}
        >
            <PrimaryAPIClientContext.Provider
                value={{
                    ...APIs,
                }}
            >
                {children}
            </PrimaryAPIClientContext.Provider>
        </ContractTypeContext.Provider>
    );
};
